import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Layout as LayoutComponent } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import Header from './headerComponent/HeaderComponent';
import Sidebar from './sidebarComponent/SidebarComponent';
import { toggleMenuCollapsed } from '../redux/actions/app';

const Layout = (props: { children: any }): JSX.Element => {
  const { children } = props;

  const dispatch = useDispatch();
  const collapsed = useSelector((state) => state.app.collapsed);

  const toggleMenu = (): void => {
    dispatch(toggleMenuCollapsed());
  };

  useEffect(() => {
    if (window.innerWidth < 664) {
      toggleMenu();
    }
  }, []);

  return (
    <LayoutComponent style={{ minHeight: '100vh' }}>
      <Sidebar />
      <LayoutComponent>
        <Header />
        <LayoutComponent.Content>
          <div id="main-content">
            {window.innerWidth <= 425 && !collapsed ? null : children}
          </div>
        </LayoutComponent.Content>
      </LayoutComponent>
    </LayoutComponent>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Layout;
